import { render } from "./MoreDetails.vue?vue&type=template&id=1156e291&scoped=true"
const script = {}

import "./MoreDetails.vue?vue&type=style&index=0&id=1156e291&lang=scss&scoped=true"

import exportComponent from "E:\\work\\flaggerforce\\flagger-force-orders-module\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1156e291"]])

export default __exports__